import React from 'react';
import {CheckBox} from "./CheckBox";
import _ from "lodash";

export let CheckBoxSet = function (props) {
    function onChange(option, checked) {
        let updatedValues = _.cloneDeep(props.values || [])
        if (updatedValues.includes(option.value) && !checked) {
            updatedValues = _.filter(updatedValues, (pickedValue) => {
                return pickedValue !== option.value
            })
        } else if (!updatedValues.includes(option.value) && checked) {
            updatedValues.push(option.value)
        }
        updatedValues = _.uniq(updatedValues)
        props.onChange(updatedValues);
    }

    let checkboxesDisplay = [];
    for (let i = 0; i < props.options.length; i++) {
        let option = props.options[i];
        checkboxesDisplay.push(
            <CheckBox
                key={i}
                id={`stripePaymentMethod-${option.value}`}
                checked={(props.values || []).includes(option.value)}
                onChange={(checked) => onChange(option, checked)}
                label={option.label}
                sublabel={option.sublabel}
                disabled={option.disabled}
            />
        )
    }

    return (
        <div className="common-form-checkbox-set">
            {checkboxesDisplay}
        </div>
    );
};
